import classNames from "classnames";
import "./style.scss";

const A = props => {
  const newProps = { ...props };
  newProps.className = classNames("a", newProps.className);
  return <span {...newProps} />;
};

export default A;
